interface CountBadgeProps {
    count: number;
    fs?: number;
    dimension?: string;
}

const CountBadge = ({count, fs=12, dimension}: CountBadgeProps) => {
    return (<>
        {count>0
            ? (<span className={`badge bg-light-success d-block d-md-inline mb-1  fs-${fs}`}>+{count} {dimension}</span>)
            : (<span className={`badge bg-light-danger d-block d-md-inline mb-1 fs-${fs}`}>{count} {dimension}</span>)}
    </>)
}

export default CountBadge;